import type { Web3TxMultiCalcSWR, Web3TxRoutes } from "@/hooks/tx-flow/useDepositCalculate";
import type { AxiosError } from "axios";

export function getWeb3TxRoutes(
  vaultId: string,
  txCalculate: Web3TxMultiCalcSWR
): { calculateError: Error | undefined; calculatedRoute: Web3TxRoutes | undefined; isError: boolean } {
  const foundResult = txCalculate.data?.find(result => result.in.vault_id === vaultId);
  const calculatedRoute = foundResult?.liq.ok
    ? ({
        liq: foundResult.liq,
        in: foundResult.in,
        routes: foundResult.liq.routes,
      } as Web3TxRoutes)
    : undefined;

  const endpointError = txCalculate.error ? new Error((txCalculate.error as AxiosError<{ detail: string }>).response?.data.detail, { cause: "endpoint" }) : undefined;
  return {
    calculatedRoute,
    calculateError: endpointError ? endpointError : foundResult && !foundResult.liq.ok ? new Error(foundResult.liq.route_error, { cause: "route" }) : undefined,
    isError: txCalculate.isError || (!!txCalculate.data && !foundResult?.liq?.ok),
  };
}
